module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrap"
  }, [_vm._v("发现模块")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7326409a"}!./~/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Discover/index.vue
// module id = 162
// module chunks = 1